import SyncAnimation from './SyncAnimation';

export default function Hero() {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-layout">
          <div className="hero-text">
            <div className="hero-badge">
              <span className="badge-dot" />
              <span><strong>Certifikovaný partner Money S3</strong> od Seyfor</span>
            </div>
            <h1>Přestaňte platit účetní<br />za <span className="accent">přepisování dokladů</span></h1>
            <p className="hero-sub">
              Každý měsíc ručně kopírujete stovky faktur, objednávek a plateb do Money S3.{' '}
              <strong>Stojí vás to 37+ hodin a tisíce korun na chybách.</strong>{' '}
              SyncroX to celé zautomatizuje — za méně, než kolik stojí jedna hodina práce účetní.
            </p>
            <div className="hero-ctas">
              <a href="#cta" className="btn-primary">
                Chci bezplatnou konzultaci
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14" /><path d="M12 5l7 7-7 7" /></svg>
              </a>
              <a href="#solutions" className="btn-secondary">Jak to funguje</a>
            </div>
            <div className="hero-proof">
              <div className="hero-proof-item"><div className="number">200+</div><div className="label">firem<br />synchronizuje</div></div>
              <div className="hero-proof-divider" />
              <div className="hero-proof-item"><div className="number">500 000+</div><div className="label">dokladů<br />měsíčně</div></div>
              <div className="hero-proof-divider" />
              <div className="hero-proof-item"><div className="number">10 let</div><div className="label">zkušeností<br />s integrací</div></div>
              <div className="hero-proof-divider" />
              <div className="hero-proof-item"><div className="number">0</div><div className="label">skrytých<br />poplatků</div></div>
            </div>
          </div>
          <div className="hero-visual">
            <SyncAnimation />
          </div>
        </div>
      </div>
    </section>
  );
}
